import {
  CheckCircle2,
  CircleAlert,
  CircleX,
  Info,
  LoaderCircle,
} from 'lucide-react'
import { useEffect } from 'react'

const configuracionPorTipo = {
  success: {
    icono: CheckCircle2,
    iconoClase: 'bg-emerald-100 text-emerald-600',
    botonClase: 'bg-emerald-600 hover:bg-emerald-700',
  },
  error: {
    icono: CircleX,
    iconoClase: 'bg-red-100 text-red-600',
    botonClase: 'bg-red-600 hover:bg-red-700',
  },
  warning: {
    icono: CircleAlert,
    iconoClase: 'bg-amber-100 text-amber-600',
    botonClase: 'bg-amber-600 hover:bg-amber-700',
  },
  info: {
    icono: Info,
    iconoClase: 'bg-blue-100 text-blue-600',
    botonClase: 'bg-blue-600 hover:bg-blue-700',
  },
  confirm: {
    icono: CircleAlert,
    iconoClase: 'bg-amber-100 text-amber-600',
    botonClase: 'bg-red-600 hover:bg-red-700',
  },
}

function ModalMensaje({
  abierto,
  tipo = 'info',
  titulo,
  mensaje,
  textoAceptar = 'Aceptar',
  textoCancelar = 'Cancelar',
  mostrarCancelar = false,
  procesando = false,
  onAceptar,
  onCancelar,
}) {
  const cerrar = onCancelar || onAceptar

  useEffect(() => {
    if (!abierto) return

    const alPresionarTecla = (event) => {
      if (event.key === 'Escape' && !procesando) {
        cerrar?.()
      }
    }

    document.addEventListener('keydown', alPresionarTecla)

    return () => {
      document.removeEventListener('keydown', alPresionarTecla)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abierto, procesando])

  if (!abierto) return null

  const config =
    configuracionPorTipo[tipo] || configuracionPorTipo.info
  const Icono = config.icono

  const alHacerClicFuera = (event) => {
    if (procesando) return

    if (event.target === event.currentTarget) {
      cerrar?.()
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4"
      onMouseDown={alHacerClicFuera}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-mensaje-titulo"
        className="w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-xl sm:p-8"
      >
        <div
          className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${config.iconoClase}`}
        >
          {procesando ? (
            <LoaderCircle
              size={28}
              className="animate-spin"
            />
          ) : (
            <Icono size={28} />
          )}
        </div>

        {titulo && (
          <h2
            id="modal-mensaje-titulo"
            className="mt-5 text-lg font-bold text-slate-900"
          >
            {titulo}
          </h2>
        )}

        {mensaje && (
          <p className="mt-2 text-sm text-slate-600">{mensaje}</p>
        )}

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
          {mostrarCancelar && (
            <button
              type="button"
              onClick={onCancelar}
              disabled={procesando}
              className="w-full rounded-lg border border-slate-300 px-5 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
            >
              {textoCancelar}
            </button>
          )}

          <button
            type="button"
            onClick={onAceptar}
            disabled={procesando}
            className={`flex w-full items-center justify-center gap-2 rounded-lg px-5 py-2.5 font-semibold text-white transition disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto ${config.botonClase}`}
          >
            {procesando && (
              <LoaderCircle
                size={18}
                className="animate-spin"
              />
            )}
            {textoAceptar}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalMensaje
